import { applyDataVariantOverrides } from "data/applyVariantOverrides";
import { ProductData } from "data/product/products";

import { convertSecondsToHoursAndMinutes } from "~/util/stringUtils";

import VIDEO_DATA from "./videoProductPage.json";

export interface VideoData {
  product: Product;
  videoFor: VideoFor;
  reviews: SingleReview[];
  whoIsAuthor: WhoIsAuthor;
  behindTheScenes: SingleBehindTheScenes[];
}

export interface Product {
  title: string;
  description: string;
  details: Details;
  topics: string[];
  videos: Videos[];
  previewImageUrl: string;
  previewImageAlt: string;
  newPrice: number;
  oldPrice: number;
  endOfferDate: string;
  included: Include[];
}

export interface Details {
  trailerVideoURL: string;
  authorName: string;
  authorIconUrl: string;
  authorIconAlt: string;
  rating: string;
  reviewsNumbers: string;
  duration: string;
  date: string;
}

export interface Videos {
  videoUrl: string;
  previewImageUrl: string;
  description: string;
  duration: string;
}

export interface Include {
  iconUrl: string;
  text: string;
}

export interface VideoFor {
  descriptions: Description[];
}

export interface Description {
  text: string[];
}

export interface Reviews {
  descriptions: SingleReview[];
}

export interface SingleReview {
  iconUrl: string;
  reviewerName: string;
  date: string;
  lastUpdatedAt: string;
  reviewText: string;
  reviewerProfileImageURL: string;
  rankIndex: number;
}

export interface BehindTheScenes {
  behindTheScenes: SingleBehindTheScenes[];
}

export interface SingleBehindTheScenes {
  title: string;
  iconUrl: string;
  textContent: string;
}

export interface WhoIsAuthor {
  iconUrl: string;
  title: string;
  shortDescription: string;
  textContent: string;
  videos: Video[];
}

export interface Video {
  thumbnail: string;
  title: string;
  rating: number;
  totalRating: number;
  date: string;
  duration: string;
  regularPrice: number;
  salePrice: number;
  tags: string[];
}

export const getVideoData = (variant?: string): VideoData => {
  const data = applyDataVariantOverrides(VIDEO_DATA as any, variant) as VideoData;
  return data;
};

export const getTemplateVideoData = (variant?: string): VideoData => {
  const data = applyDataVariantOverrides(VIDEO_DATA as any, variant) as VideoData;
  return data;
};

export const getIncludedSectionData = (productData: ProductData): Include[] => {
  let content_total_length = 0;
  for (let content of productData.content || []) {
    content_total_length += Number(content.lengthInSeconds) || 0;
  }
  if (productData.totalVideoLengthInSeconds && productData.totalVideoLengthInSeconds > 0) {
    content_total_length = Number(productData.totalVideoLengthInSeconds);
  }
  const marketingDuration = convertSecondsToHoursAndMinutes(content_total_length);
  const videoLengthText = `In-depth video lessons (${marketingDuration})`;
  const includedSectionData: Include[] = [
    {
      iconUrl:
        "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/movie_filter_FILL0_wght400_GRAD0_opsz48_1_1_iyratj.svg",
      text: videoLengthText,
    },
    {
      iconUrl:
        "https://res.cloudinary.com/monthly/image/upload/v1674119495/monthly-admin-images/behind-scenes-product/video-page/icon/magic-stick_ldmxww.svg",
      text: "Step-by-step curriculum",
    },
    {
      iconUrl:
        "https://res.cloudinary.com/monthly/image/upload/v1683032324/monthly-admin-images/icons/sentiment_satisfied_FILL0_wght400_GRAD0_opsz48_1_lgqsti.svg",
      text: "Online and at your own pace",
    },
    {
      iconUrl:
        "https://res.cloudinary.com/monthly/image/upload/v1674119495/monthly-admin-images/behind-scenes-product/video-page/icon/devices_mx8fy9.svg",
      text: "Watch on all devices",
    },
    {
      iconUrl:
        "https://res.cloudinary.com/monthly/image/upload/v1674119495/monthly-admin-images/behind-scenes-product/video-page/icon/infinity_di9x8k.svg",
      text: "Unlimited lifetime access",
    },
  ];

  return includedSectionData;
};
